import { FC, useRef, useState } from 'react'
import { Center, useMediaQuery, useRadio } from '@chakra-ui/react'
import { HStack, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import { RadioButton } from './radio-button'
import theme from '../../styles'
import { selectAnswers } from '../../state'
import { Steps } from '../../state/interfaces'
import { useSelector } from 'react-redux'

export const ExtraLargePillRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const answers = useSelector(selectAnswers)
  const answerStep: string = answers[Steps.VALUE_THE_MOST_CHOICES_1] ? answers[Steps.VALUE_THE_MOST_CHOICES_1]![0] : ''
  const inputRef = useRef<HTMLInputElement>(null)
  const [popUpOpened, setPopUpOpened] = useState(false)
  const [isSmallerThan900] = useMediaQuery('(max-width: 900px)')

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()

    if (!popUpOpened) {
      if (props.metadata && props.metadata.followsLink !== undefined) {
        window.open(props.metadata.followsLink, '_blank')
      }
    }

    setPopUpOpened(true)
  }

  const hasBackground = () => {
    return props.metadata && props.metadata.background !== undefined
  }

  const pillBackground = hasBackground() ? props.metadata!.background : ''

  return (
    <HStack
      as="label"
      cursor="pointer"
      data-testid={`pill-${props.value}`}
      display="flex"
      justifyContent="center"
      className={answerStep && (answerStep === props.value ? 'disabled' : '')}
      tabIndex={0}
      onFocus={handleFocus}
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 2px #5bce4c',
      }}
      onClick={handleClick}
    >
      <Center
        {...getRadioProps()}
        layerStyle={theme.LayerStyles.EXTRA_LARGE_PILL}
        backgroundColor={pillBackground}
        aria-label={`button-${props.label}`}
        width={isSmallerThan900 ? '45vh' : '50vh'}
      >
        <RadioButton {...getInputProps()} ref={inputRef} />
        <Text textAlign="center">{props.label}</Text>
      </Center>
    </HStack>
  )
}
